export const CREATE_BIKE_MODEL_REQUEST = 'CREATE_BIKE_MODEL_REQUEST';
export const CREATE_BIKE_MODEL_REQUEST_SUCCESS = 'CREATE_BIKE_MODEL_REQUEST_SUCCESS';
export const CREATE_BIKE_MODEL_REQUEST_FAILURE = 'CREATE_BIKE_MODEL_REQUEST_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_model_create/redux/constants/create_bike_model.constants.js